export const payoutShowStyles = {
  loadingContainer: {
    justifyContent: 'flex-start',
    mt: 4,
  },
  card: {
    mb: 1,
  },
  listItemContainer: {
    height: '50px',
    mb: 1,
    paddingLeft: '12px',
    borderWidth: '2px',
    borderRadius: '6px',
    borderColor: 'grey.400',
  },
  statusIcon: {
    marginRight: '12px',
  },
}

export const payoutIconColorStyles = {
  grey: 'grey[500]',
  primary: 'primary.main',
  warning: 'warning.main',
  error: 'error.main',
}
